import * as React from 'react';
import { StepButton as StepButton$1 } from '@mui/material';

var StepButton = function StepButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      icon = _ref.icon,
      focusRipple = _ref.focusRipple,
      _ref$disableRipple = _ref.disableRipple,
      disableRipple = _ref$disableRipple === void 0 ? false : _ref$disableRipple,
      sx = _ref.sx;
  return /*#__PURE__*/React.createElement(StepButton$1, {
    focusRipple: focusRipple || false,
    icon: icon,
    onClick: onClick,
    disableRipple: disableRipple,
    sx: sx
  }, children);
};

StepButton.displayName = 'StepButton';
export { StepButton };